import React, { useEffect, useState } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import {
	ToothPathologyDevelopmentDisorderValues,
	ToothPresence,
} from '../../../../graphql/graphql';
import useTooth from '../../Hooks/Tooth/useTooth';

const DENTModalOverviewPathologyDevelopmentDisorder = () => {
	const {
		pathology: { developmentDisorder },
	} = useTooth();

	const [values, setValues] = useState<
		ToothPathologyDevelopmentDisorderValues | undefined
	>(developmentDisorder.values);

	useEffect(() => {
		if (values) developmentDisorder.setValues(values);
	}, [values]);

	const handleChangePresence = (value: ToothPresence) =>
		setValues(prev => ({
			...prev,
			presence: prev?.presence === value ? undefined : value,
		}));

	const rows = [
		{
			shouldHide: false,
			items: [
				{
					title: 'base.yes',
					isSelected: values?.presence === ToothPresence.Yes,
					onClick: () => handleChangePresence(ToothPresence.Yes),
				},
				{
					title: 'base.no',
					isSelected: values?.presence === ToothPresence.No,
					onClick: () => handleChangePresence(ToothPresence.No),
				},
			],
		},
	];

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewPathologyDevelopmentDisorder;
